import { Directive, ViewContainerRef, ElementRef, HostListener } from '@angular/core';
import { SyncService } from '../services/sync.service';
import { UtilityServiceForMedicalService } from '../services/utility-service';
@Directive({
    selector: '[validation-accordion-dir]'
})

export class AccordionValidateEventEmitterDirective {
    constructor(private utilityServiceForMedicalService: UtilityServiceForMedicalService) {
    }

    @HostListener('click', ['$event']) onClick(event: MouseEvent) {
        //console.log('accordion event');  
    }

}
